import { createAction, stringDuckCreator } from '@atc/modular-redux';

export default function dealerSearchPathCreator({
    namespace = '',
    store = 'dealerSearchPath',
    storePrefix,
    initialState = '',
} = {}) {
    return stringDuckCreator({
        initialState,
        namespace,
        store,
        storePrefix,
    }).extend({
        creators: ({ types }) => ({
            setDealerSearchPath: createAction(types.SET),
        }),
    });
}
